<template>
  <div>
    <div
      v-if="!notFound"
      class="messenger"
    >
      <div class="messenger__dialogs">
        <dialogs
          @not-found="notFound = $event"
        />
      </div>
      <div class="messenger__chat">
        <chat
          v-if="currentClient.client_id"
          :key="currentClient.client_id"
        />
        <div
          v-else
          class="messenger-chat-empty"
        >
          Выберите чат для общения
        </div>
      </div>
    </div>
    <div
      v-else
    >
      <not-found
        @not-found="notFound = $event"
      />
    </div>
  </div>
</template>

<script>
import NotFound from './NotFound.vue'
import Dialogs from './dialogs/Dialogs.vue'
import Chat from './chat/Chat.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    NotFound,
    Dialogs,
    Chat
  },

  data () {
    return {
      notFound: false
    }
  },

  computed: {
    ...mapGetters(['authUserCompany', 'liveToken', 'liveChannel', 'currentClient'])
  },

  async created () {
    await this.clearClients()

    await this.fetchLiveToken()
  },

  methods: {
    ...mapActions(['fetchLiveToken', 'clearClients'])
  }
}
</script>
